import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { CartDetailDTO, CartSummaryDTO } from 'src/app/core/models/shopping-cart';
import { ShoppingCartService } from 'src/app/core/services/shopping-cart.service';
import * as fromShoppingCart from '../shopping-cart/index';
import * as shoppingCartActions from '../shopping-cart/shopping-cart.action';

@Injectable({
  providedIn: 'root',
})
export class ShoppingCartDispatcher {
  constructor(private store: Store, private shoppingCartService: ShoppingCartService) {}
  dispatchTempShoppingCartDetails(idMember: number): void {
    this.store.dispatch(new shoppingCartActions.TempShoppingCartLoad(idMember));
  }
  updateTempShoppingCartDetails(cart: CartDetailDTO[]): void {
    this.store.dispatch(new shoppingCartActions.TempShoppingCartDetailsUpdate(cart));
  }
  dispatchShoppingCartDetails(idMember: number): void {
    this.store.dispatch(new shoppingCartActions.ShoppingCartLoad(idMember));
  }
  updateShoppingCartDetails(cart: CartSummaryDTO[]): void {
    this.store.dispatch(new shoppingCartActions.ShoppingCartDetailsUpdate(cart));
  }
  selectStore(): void {
    this.store.select(fromShoppingCart.getTempShoppingCartByIdMember).subscribe((cartDetails: CartDetailDTO[]) => {
      const productList = [];
      let noempPRKProduct = false;
      if (cartDetails) {
        cartDetails.forEach(cartDetailItem => {
          cartDetailItem.products.forEach(product => {
            noempPRKProduct = cartDetailItem.products.some(
              product =>
                product.parking &&
                product.parking.idParkingType === 8 &&
                product.parking.isExclusiveForEmployerParking &&
                product.parking.idApprovalStatus === 5
            );
            if (!noempPRKProduct) {
              productList.push(product);
            }
          });
        });
        this.shoppingCartService.tempCartProductsCount$.next(productList.length);
        this.shoppingCartService.tempShoppingCartDetails$.next(cartDetails);
      }
    });
  }
}
